/* tslint:disable */
/* eslint-disable */
/**
 * Magnolia Headless Helper API
 * Helper API and model definitions for breadcrumbs page navigation etc. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
    import {
        ApiBreadCrumb,
        ApiBreadCrumbFromJSON,
        ApiBreadCrumbFromJSONTyped,
        ApiBreadCrumbToJSON,
    } from './';

/**
* 
* @export
* @interface ApiBreadCrumbResponse
*/
export interface ApiBreadCrumbResponse {
    /**
    * 
    * @type {Array<ApiBreadCrumb>}
    * @memberof ApiBreadCrumbResponse
    */
    nodes?: Array<ApiBreadCrumb>;
}

export function ApiBreadCrumbResponseFromJSON(json: any): ApiBreadCrumbResponse {
return ApiBreadCrumbResponseFromJSONTyped(json, false);
}

export function ApiBreadCrumbResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiBreadCrumbResponse {
    if ((json === undefined) || (json === null)) {
    return json;
    }
    return {
    
                'nodes': ((json['nodes'] as Array<any>).map(ApiBreadCrumbFromJSON)),
        };
    }

    export function ApiBreadCrumbResponseToJSON(value?: ApiBreadCrumbResponse | null): any {
    if (value === undefined) {
    return undefined;
    }
    if (value === null) {
    return null;
    }
    return {

                    'nodes': ((value.nodes as Array<any>).map(ApiBreadCrumbToJSON)),
    };
    }


    // custom code here ##################################################################################################################
    // function toUTC(date) {
    //   var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
    //   return new Date(date_utc);
    // }

